import ModalDeleteFilled from '../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteCreditorBankProps extends ModalEditComponentProps { }

const ModalDeleteCreditorBank: React.FC<ModalDeleteCreditorBankProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/supplier/supplierBank/updateSupplierBank',
        data: {
            id: allRowData?.id,
            active: false,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteBank', '¿Seguro que quieres eliminar este banco?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteCreditorBank